import axios, { AxiosError, AxiosRequestConfig } from "axios";
import ENV from "config";
import { $Values } from "utility-types";
import { SessionHelper } from "../helpers/sessionHelper";
import UserLogic from "../logic/userLogic";
import store from "../store/store";
import { PollingIntervals, SESSION_TOKEN } from "../utils/const";
import { LanguageSelectionHelper } from "./languageSelectionHelper";

/**
 * Add the session token to the header
 */
const addHeaderSessionToken = (request: $Values<typeof AxiosRequestConfig>) => {
  const sessionToken: string = SessionHelper.getToken();

  if (sessionToken != null && sessionToken.length > 0) {
    request.headers[SESSION_TOKEN] = sessionToken;
  }

  return request;
};

/**
 * Check user is active, if user is idle don't send the request
 */
const checkUserIsActive = (request: $Values<typeof AxiosRequestConfig>) => {
  const isUserIdle = store.getState().sessionModel.isIdle;

  if (isUserIdle) {
    console.log("Cancel request: user isIdle :", isUserIdle);
    return new Promise(() => {});
  }

  return request;
};

/**
 * Intercept the error message from the api
 * to handle the unauthorized responses
 */
const interceptErrorResponse = (error: $Values<typeof AxiosError>) => {
  if (error.response != null && error.response.status === 401) {
    UserLogic.logout();
    window.location.reload();
  }

  return Promise.reject(error);
};

/**
 * Set up global Axios instance
 */
export const api: any = axios.create({
  baseURL: ENV.API_HOST,
});

/**
 * Set up global Axios instance
 */
export const apiCMS: any = axios.create({
  baseURL: ENV.API_CMS,
});

/**
 * Set up global Axios instance
 */
export const apiAMS: any = axios.create({
  baseURL: ENV.API_AMS,
});

/** Intercept the REQUEST to the API */
api.interceptors.request.use(addHeaderSessionToken);
api.interceptors.request.use(checkUserIsActive);

/** Intercept the RESPONSE from the API */
api.interceptors.response.use(resp => resp, interceptErrorResponse);

/**
 * generic fetch
 */
export const getDataSimple = (url: string): any => {
  const language = LanguageSelectionHelper.checkSelectedLanguage();
  return api
    .get(url, {
      timeout: PollingIntervals.TIMEOUT,
      headers: {
        "Accept-Language": language,
      },
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};
export const getDataWithParams = (
  url: string,
  params: Record<string, any>
): any => {
  const language = LanguageSelectionHelper.checkSelectedLanguage();
  return api
    .get(url, {
      timeout: PollingIntervals.TIMEOUT,
      params,
      headers: {
        "Accept-Language": language,
      },
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};
